import { InfiniteData, useMutation } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { Creator } from '~/clientApi/creator.model';
import { queryClient } from '~/config/reactQueryConfig';
import {
  AGENCIES_COLLECTION_QUERY_KEY,
  AGENCY_MANAGEMENT_CREATORS_COLLECTION_QUERY_KEY,
  CREATOR_PROFILE_QUERY_KEY,
  SAVED_LIST_CREATORS,
  TR_CREATORS_LIST_QUERY_KEY,
} from '~/queries/keys';
import { ICreator } from '~/types';

interface UpdateCreatorPayload extends Partial<Creator> {
  id: string;
}

export const useUpdateCreator = () => {
  const mutation = useMutation(
    (newCreator: UpdateCreatorPayload) =>
      clientApi.creators.update({
        ...newCreator,
      }),
    {
      onSuccess: (updatedCreator: ICreator) => {
        if (updatedCreator?.slug) {
          // Creator profile
          queryClient.setQueryData(
            [CREATOR_PROFILE_QUERY_KEY, { slug: updatedCreator.slug }],
            updatedCreator,
          );
        }

        // My Agency
        queryClient.setQueriesData(
          [AGENCIES_COLLECTION_QUERY_KEY],
          updateSingleCreator(updatedCreator),
        );

        // My roster
        queryClient.setQueriesData(
          [TR_CREATORS_LIST_QUERY_KEY],
          updateSingleCreator(updatedCreator),
        );

        // Saved List
        queryClient.setQueriesData(
          [SAVED_LIST_CREATORS],
          updateSingleCreator(updatedCreator),
        );

        // Agency Settings talent tab
        queryClient.setQueriesData(
          [AGENCY_MANAGEMENT_CREATORS_COLLECTION_QUERY_KEY],
          updateSingleCreator(updatedCreator),
        );
      },
    },
  );

  return mutation;
};

const updateSingleCreator =
  (updatedCreator: ICreator) =>
  (
    creatorOldReqData: InfiniteData<
      | {
          results: Creator[];
        }
      | undefined
    >,
  ) => {
    if (!creatorOldReqData || !creatorOldReqData.pages) {
      return creatorOldReqData;
    }

    return {
      ...creatorOldReqData,
      pages: creatorOldReqData.pages.map((page) => {
        return {
          ...page,
          results: page?.results.map((creator) => {
            if (creator.id === updatedCreator.id) {
              return { ...creator, ...updatedCreator };
            }
            return creator;
          }),
        };
      }),
    };
  };
